import { Box, Stack } from '@chakra-ui/react';

import { FCWithChildren } from 'common/types';

const Aside: FCWithChildren = (props) => (
  <Box paddingRight="space-64">
    <Stack spacing="space-24" width="350px" {...props}></Stack>
  </Box>
);

export default Aside;
